class ProductComparison extends HTMLElement {
  constructor() {
    super();

    this.items = this.querySelectorAll(".js-comparison-product");
    this.tables = this.querySelectorAll(".js-comparison-table");

    this.items.forEach((item) => {
      item.addEventListener("click", () => {
        this.items.forEach((allItem) => {
          allItem.classList.remove("selected");
        });
        item.classList.add("selected");

        const tableIndex = item.getAttribute("data-table-index");
        if (this.tables.length) {
          this.tables.forEach((table) => {
            table.classList.add("hidden");
          });

          if (tableIndex && this.tables[tableIndex]) {
            this.tables[tableIndex].classList.remove("hidden");
          }
        }
      });
    });
  }
}

customElements.define("product-comparison", ProductComparison);
